import { removeEmptyObjects } from 'util/removeEmptyObjects'
import { doPost } from './common'

export const validateTokenService = async ({
  tokenSourceId,
  tokenSource,
  token,
  type = 'EMAIL',
  phoneNumber,
  email,
}) => {
  const payload = removeEmptyObjects({
    tokenSourceId,
    tokenSource,
    token,
    phoneNumber,
    type,
    email,
  })

  try {
    const res = await doPost(`/token/validate-token`, payload)
    if (res.status === 200) {
      return true
    }
  } catch (error) {
    return false
  }
}

export const validateTokenPrivacyService = async ({
  tokenSourceId,
  tokenSource,
  token,
  email,
  firstName,
  lastName,
  state,
  details,
  requestType,
  type,
}) => {
  const payload = removeEmptyObjects({
    tokenSourceId,
    tokenSource,
    token,
    email,
    firstName,
    lastName,
    state,
    details,
    requestType,
    type,
  })

  try {
    const res = await doPost(`/token/validate-token-privacy`, payload)
    if (res.status === 200) {
      return true
    }
  } catch (error) {
    return false
  }
}

export const generateTokenService = ({
  tokenSourceId,
  tokenSource,
  permalink,
  email,
  phoneNumber,
  type = 'EMAIL',
  firstName,
  lastName,
  turnstileToken
} = {}) => {
  const payload = removeEmptyObjects({
    email,
    tokenSourceId,
    tokenSource,
    permalink,
    phoneNumber,
    type: type.toUpperCase(),
    firstName: firstName || email,
    lastName: lastName || '',
    turnstileToken
  })

  return doPost(`/token/generate-token`, payload)
}
